export const GPS_FIX_MAX_UNEXPLAINED_DISPLACEMENT_M = 15

export const GPS_FIX_MAX_PLAUSIBLE_GROUND_SPEED_KMH = 500

export const GPS_FIX_MAX_USABLE_DOP = 5

export const GPS_FIX_RESYNC_S = 2

export const GPS_FIX_MIN_MOVING_SPEED_KMH = 20

export const GPS_FIX_TRUSTED_SPEED_TO_TRACK_RATIO = { min: 0.8, max: 1.25 }

export const GPS_TIME_MAX_STALLED_SHARE = 0.01

export const GPS_SPEED_WINDOW_MS = 1000

export const GPS_SPEED_NEVER_MOVING_MIN_M = 250

export const GPS_SPEED_NEVER_MOVING_MIN_RUN_WINDOWS = 3

export const GPS_SPIKE_MAX_FIXES = 10

export const GPS_SPIKE_STEP_QUANTILE = 0.9

export const GPS_SPIKE_STEP_FACTOR = 3

export const LAP_DISTANCE_TO_SPEED_RATIO = { min: 0.8, max: 1.25 }

export const LAP_DISTANCE_CHECK_MIN_MOVING_M = 250
